import React from 'react';
import Button from '@mui/material/Button';

type FieldProps = {
  handleSave: Function;
  handleCancel: Function;
  saveText: string;
  cancelText: string;
  continueText: string;
  isSuccess: boolean;
  isReadyToSave?: boolean;
  cancelBtnStyle?: object;
  successBtnStyle?: object;
};

const Footer = ({
  handleSave = () => {},
  handleCancel = () => {},
  saveText = 'Save',
  cancelText = 'Close',
  continueText = 'Continue',
  isSuccess = false,
  isReadyToSave = false,
  cancelBtnStyle,
  successBtnStyle,
}: FieldProps): JSX.Element =>
  !isSuccess ? (
    <>
      <Button
        id="mfe_cancel-button"
        data-testid="mfe_cancel-button"
        onClick={() => handleCancel()}
        variant="text"
        style={cancelBtnStyle}
        size="medium"
      >
        {cancelText}
      </Button>
      <Button
        id="mfe_save-button"
        data-testid="mfe_save-button"
        onClick={() => handleSave()}
        variant="contained"
        disabled={!isReadyToSave}
        style={successBtnStyle}
        size="large"
      >
        {saveText}
      </Button>
    </>
  ) : (
    <Button
      id="mfe_continue-button"
      data-testid="mfe_continue-button"
      data-adp-click="true"
      onClick={() => handleCancel()}
      variant="contained"
      size="large"
      style={successBtnStyle}
    >
      {continueText}
    </Button>
  );

export default Footer;
